function SEO_Cookiebot() {
  const ga4_tag = process.env.GA4_TAG;
  const adwords_tag = process.env.ADWORDS_TAG;
  const ga4_url = 'https://www.googletagmanager.com/gtag/js?id=' + ga4_tag;

  const fb_pixel_id = process.env.FB_PIXEL_ID;

  return (
    <>
      <script
        src="https://ccm.envision.at/ccm19/public/app.js?apiKey=b30b0669963c335b24485ace212d409d43e6c592e815e651&amp;domain=33bd57b"
        referrerPolicy="origin"
        async
      ></script>
      <script async src={ga4_url}></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${ga4_tag}');
                 gtag('config', '${adwords_tag}');
              `,
        }}
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `
                !(function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
              })(
                window,
                document,
                'script',
                'https://connect.facebook.net/en_US/fbevents.js'
              );
              fbq('init', '${fb_pixel_id}');
              fbq('track', 'PageView');
              `,
        }}
      />

      <script
        async={true}
        type={`text/javascript`}
        src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RAENQY`}
      />
    </>
  );
}

export default SEO_Cookiebot;
